var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.772 7.4A2 2 0 0 0 1 8.977V18a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8.978a2 2 0 0 0-.772-1.579l-7.614-5.922a1 1 0 0 0-1.228 0L1.772 7.4ZM8 12a1 1 0 0 0-1 1v6h6v-6a1 1 0 0 0-1-1H8Z",
    clipRule: "evenodd"
  })));
};
export default SvgHome;